/**
 * Created by Ivan on 07.07.2026
 */

const StickersBookWindow = Prefab.createWindow("stickers_book_window", "stickers_book_window_prefab_json");
